import { FC, useState } from 'react';

import Link from 'next/link';
import Pagination from '@/components/ui/pagination/Pagination';
import styles from './PaginationBlock.module.scss';

interface IPaginationBlock {
  bookId: number;
  pagesCount: number;
  currentPage: number;
  extraClassName?: string;
}

const PaginationBlock: FC<IPaginationBlock> = ({ extraClassName, bookId, pagesCount, currentPage }) => {
  const getClassName = () => (extraClassName ? `${styles.paginationBlock} ${styles[`${extraClassName}`]}` : styles.paginationBlock);

  const [inputPageNumber, setInputPageNumber] = useState(1);

  const paginationInputHandler = (e: any) => {
    const currentNumber = e.target.value;
    currentNumber > pagesCount ? setInputPageNumber(pagesCount) : setInputPageNumber(e.target.value);
  };

  return (
    <>
      {pagesCount > 1 ? (
        <div className={getClassName()}>
          <div className={styles.paginationBlock__pages}>
            <Pagination pagesCount={pagesCount ?? 0} postName={`online/${bookId}/`} extraClassName="pagination_noMargin" />
          </div>
          <div className={styles.paginationBlock__input}>
            <div className={styles.pagesInput}>
              <div className={styles.pagesInput__controls}>
                <span className={styles.pagesInput__txt}>На страницу:</span>
                <div className={styles.pagesInput__input}>
                  <input data-page-go-input className={styles.formInput__field} name="page-number" type="number" min="1" max={pagesCount} value={inputPageNumber} placeholder="1" onChange={paginationInputHandler} />
                </div>
                <div className={styles.pagesInput__btn}>
                  <Link prefetch={false} data-page-go-button className={styles.paginationBlock__btn} href={`/online/${bookId}/${inputPageNumber}`}>
                    Перейти
                  </Link>
                </div>

                <div className={styles.pagesInput__count}>
                  <span data-current-page="{{ currentPage }}" className={styles.pagesInput__countCurrent}>
                    {currentPage}
                  </span>{' '}
                  из{' '}
                  <span data-total-pages="{{ totalPages }}" className={styles.pagesInput__countTotal}>
                    {pagesCount}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default PaginationBlock;
